import {createContext, useContext} from 'react';

import type {AppLocals} from './types';

export type AppError = {message: string; status?: number; stack?: string};

/**
 * Per-request (server) / per-page-load (client) values that `root.tsx` needs to mount the
 * brand `AppConfig` and `App`. Provided by `entry.server` / `entry.client` around the router,
 * because PWA Kit used to pass them as props from its own renderer.
 */
export type AppBootstrap = {
	locals: AppLocals;
	messages: Record<string, unknown>;
	detectedLanguage?: string;
	envPreferences: Record<string, unknown>;
	appProps: Record<string, unknown>;
	correlationId: string | (() => string);
	error?: AppError;
	onHydrate?: () => void;
};

export const AppBootstrapContext = createContext<AppBootstrap | null>(null);

export const useAppBootstrap = (): AppBootstrap => {
	const bootstrap = useContext(AppBootstrapContext);

	if (!bootstrap) {
		throw new Error('AppBootstrapContext is missing: wrap <ServerRouter>/<HydratedRouter> with it.');
	}

	return bootstrap;
};
